import * as React from 'react'
import { Suspense } from 'react'

// Context
import { SubmissionProvider } from '@app/context/SubmissionProvider'

const withProvider = (Component: React.SFC<{}>) => (props: WithProvider.IProps) => {
  const { config } = props

  return <Suspense fallback={null}>
    <SubmissionProvider config={config}>
      <Component {...props} />
    </SubmissionProvider>
  </Suspense>
}

export default withProvider
